<template>
  <v-card outlined class="px-6">
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 grey--text pt-1 mt-4">Trending</label>
      <v-switch v-model="trendingListener"/>
    </div>
    <v-select
      label="Selected States"
      :items="usStates"
      outlined
      multiple
      v-model="statesListener"
      :disabled="!trending || loadingStates"
      :loading="loadingStates"
      clearable
      item-text="name"
      item-value="id"
    ></v-select>
    <v-menu
      v-model="showTrendingExpireDate"
      transition="scale-transition"
      min-width="290px"
      :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            label="Expiration Date"
            prepend-inner-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :disabled="!trending"
            v-model="expirationDateListener"
            clearable
            :error-messages="expirationDateErrorMessages"
          ></v-text-field>
        </template>

        <v-date-picker
          no-title
          v-model="expirationDateListener"
          @input="showTrendingExpireDate = false">
        </v-date-picker>
      </v-menu>
    </v-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
import isNull from 'lodash/isNull'

export default {
  props: {
    trending: {
      type: Boolean,
      default: true
    },
    states: {
      type: Array,
      default () {
        return null
      }
    },
    expirationDate: {
      type: String,
      default: null
    },
    expirationDateErrorMessages: {
      type: [Array, String],
      default () {
        return null
      }
    }
  },
  data () {
    return {
      loadingStates: false,
      showTrendingExpireDate: false
    }
  },
  computed: {
    ...mapState({
      usStates: state => state.usStates.list
    }),
    trendingListener: {
      get () {
        return this.trending
      },
      set (val) {
        this.$emit('update:trending', val)
      }
    },
    statesListener: {
      get () {
        return this.states
      },
      set (val) {
        this.$emit('update:states', val)
      }
    },
    expirationDateListener: {
      get () {
        if (!isNull(this.expirationDate)) {
          return dayjs(this.expirationDate).format('YYYY-MM-DD')
        }
        return null
      },
      set (val) {
        this.$emit('update:expiration-date', val)
      }
    }
  },
  watch: {
    trending (val) {
      if (!val) {
        this.$emit('update:states', [])
        this.$emit('update:expiration-date', null)
      }
    },
    expirationDate: {
      immediate: true,
      handler (val) {
        if (val) {
          this.$emit('update:expiration-date', dayjs(val).format('YYYY-MM-DD'))
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getStates: 'usStates/getStates'
    })
  },
  mounted () {
    this.loadingStates = true
    this.getStates({ page: 1 })
      .finally(() => { this.loadingStates = false })
  }
}
</script>
